import React, { useEffect, useState } from 'react';
import s from './styles.module.css';
import logo from '../../assets/logo-aman.png';
import { useNavigate } from 'react-router-dom';
import RegisterForm from './register-form';
import LoginForm from './login-form';
import ForgotPasswordForm from './forgot-password-form';
import { NewLogo } from '../../assets';
import { DeleteIcons } from '../../icons/login-icons/delete-icons';

const RegisterPage = ({
    isModerator,
    showRegisterForm,
    t,
    handleLanguageChange,
    language,
    isIOS,
}) => {
    const [contentType, setContentType] = useState('login');
    const navigate = useNavigate();
    const handleForgotPasswordClick = () => {
        setContentType('forgotPassword');
    };

    useEffect(() => {
        setContentType(showRegisterForm ? 'register' : 'login');
    }, [showRegisterForm]);

    const onChangeContent = () => {
        switch (contentType) {
            case 'forgotPassword':
                return <ForgotPasswordForm translation={t} />;
            case 'register':
                return (
                    <RegisterForm
                        handleLanguageChange={handleLanguageChange}
                        language={language}
                        translation={t}
                    />
                );
            case 'login':
            default:
                return (
                    <LoginForm
                        setContentType={setContentType}
                        handleLanguageChange={handleLanguageChange}
                        language={language}
                        isModerator={isModerator}
                        translation={t}
                        handleForgotPasswordClick={handleForgotPasswordClick}
                    />
                );
        }
    };

    const handleBackToLogin = () => {
        setContentType('login');
    };
    const stylePadding = {
        paddingTop: isIOS ? '51px' : '16px',
        paddingBottom: '50px',
    };
    return (
        <div className={s['outer-wrap']}>
            <div className={s['register-container']} style={stylePadding}>
                <div className={s['register-container-images']}>
                    <div className={s['div-btn']}>
                        <img className={s['image-logo']} alt={logo} src={NewLogo} preview={false} />
                    </div>
                    {contentType !== 'login' && (
                        <button className={s['go-back']} onClick={handleBackToLogin}>
                            <DeleteIcons />
                        </button>
                    )}
                    {contentType === 'login' && !isModerator && (
                        <button className={s['go-back-main']} onClick={() => navigate('/')}>
                            <DeleteIcons />
                        </button>
                    )}
                </div>
                {onChangeContent()}
            </div>
        </div>
    );
};

export default RegisterPage;
